(function () {
  var language = document.documentElement.lang.split('-')[0];
  if (language !== 'it' && language !== 'fr' && language !== 'de') return;
  function correctReviews() {
    document.querySelectorAll('.jdgm-rev-widg__title, .jdgm-rev-widg__summary-text, .jdgm-prev-badge__text, .jdgm-write-rev-link').forEach(function (element) {
      var text = element.textContent.trim();
      var next = text;
      if (element.classList.contains('jdgm-rev-widg__title')) next = language === 'fr' ? 'Avis clients' : language === 'de' ? 'Kundenbewertungen' : 'Recensioni';
      else if (element.classList.contains('jdgm-write-rev-link')) next = language === 'fr' ? 'Rédiger un avis' : language === 'de' ? 'Bewertung schreiben' : 'Scrivi una recensione';
      else {
        if (language === 'de') {
          next = next.replace(/^Based on (\d+) reviews?$/i, 'Basierend auf $1 Bewertungen').replace(/^(\d+) reviews?$/i, '$1 Bewertungen').replace(/^No reviews$/i, 'Noch keine Bewertungen').replace(/^Be the first to write a review$/i, 'Schreiben Sie die erste Bewertung').replace(/\b1 Bewertungen\b/g, '1 Bewertung');
        } else if (language === 'fr') {
          next = next.replace(/^Based on (\d+) reviews?$/i, 'Basé sur $1 avis');
          next = next.replace(/^(\d+) reviews?$/i, '$1 avis');
          next = next.replace(/^(\d+) Commentaires$/i, '$1 avis');
          next = next.replace(/^No reviews$/i, 'Aucun avis');
          next = next.replace(/^Be the first to write a review$/i, 'Soyez le premier à donner votre avis');
        } else {
        next = next.replace(/\brevisioni\b/gi, 'recensioni').replace(/\brevisione\b/gi, 'recensione');
        next = next.replace(/^Based on (\d+) reviews?$/i, 'Basato su $1 recensioni');
        next = next.replace(/^(\d+) reviews?$/i, '$1 recensioni');
        if (/\b1 recensioni\b/.test(next)) next = next.replace(/\b1 recensioni\b/g, '1 recensione');
        }
      }
      if (next !== text) element.textContent = next;
      element.classList.add('notranslate');
      element.setAttribute('translate', 'no');
    });
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; correctReviews(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  correctReviews();
}());
